/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_Ms_Sg2Inputs */

const en_language_ms_sg2 = /** @type {(inputs: Language_Ms_Sg2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melayu`)
};

const fr_language_ms_sg2 = /** @type {(inputs: Language_Ms_Sg2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melayu`)
};

const ms_sg2_language_ms_sg2 = /** @type {(inputs: Language_Ms_Sg2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melayu`)
};

/**
* | output |
* | --- |
* | "Melayu" |
*
* @param {Language_Ms_Sg2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
const language_ms_sg2 = /** @type {((inputs?: Language_Ms_Sg2Inputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_Ms_Sg2Inputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language_ms_sg2(inputs)
	if (locale === "fr") return fr_language_ms_sg2(inputs)
	return ms_sg2_language_ms_sg2(inputs)
});
export { language_ms_sg2 as "language_ms-SG" }